import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamation, faTimes } from '@fortawesome/free-solid-svg-icons';

const alertStyle = {
  color: 'white',
  padding: '15px',
  borderRadius: '3px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.25)',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  margin: '15px'
};

const buttonStyle = {
  marginLeft: '20px',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
};

const AlertTemplate = ({ message, options, style, close }) => {
  switch (options.type) {
    case 'success':
      return (
        <div style={{
          ...alertStyle, ...style,
          backgroundColor: 'rgb(231,237,216)',
          color: '#89a63a',
          borderRadius: '3px',
          fontWeight: 'bold',
          boxShadow: 'none',
          fontFamily: 'Gadugi,sans-serif',
        }}>
          <FontAwesomeIcon icon={faCheck}/>
          <span style={{ marginLeft: '15px' }}>{message}</span>
          <button onClick={close} style={buttonStyle}>
            <FontAwesomeIcon icon={faTimes} style={{ color: '#89a63a' }}/>
          </button>
        </div>
      );
    case 'error':
      return (
        <div style={{
          ...alertStyle, ...style,
          backgroundColor: 'rgb(241,204,223)',
          color: '#bb0060',
          borderRadius: '3px',
          fontWeight: 'bold',
          boxShadow: 'none',
          fontFamily: 'Gadugi,sans-serif',
        }}>
          <FontAwesomeIcon icon={faExclamation}/>
          <span style={{ marginLeft: '15px' }}>{message}</span>
          <button onClick={close} style={buttonStyle}>
            <FontAwesomeIcon icon={faTimes} style={{ color: '#bb0060' }}/>
          </button>
        </div>
      );
    case 'info':
      return (
        <div style={{
          ...alertStyle, ...style,
          backgroundColor: 'rgb(217,239,247)',
          color: '#0094ca',
          borderRadius: '3px',
          fontWeight: 'bold',
          boxShadow: 'none',
          fontFamily: 'Gadugi,sans-serif',
        }}>
          <span style={{ marginLeft: '15px' }}>{message}</span>
          <button onClick={close} style={buttonStyle}>
            <FontAwesomeIcon icon={faTimes} style={{ color: '#0094ca' }}/>
          </button>
        </div>
      );
    default:
      return (
        <div style={{ ...alertStyle, ...style }}>
          {options.type === 'success' && <FontAwesomeIcon icon={faCheck}/>}
          {options.type === 'error' && <FontAwesomeIcon icon={faExclamation}/>}
          <span style={{ marginLeft: '15px' }}>{message}</span>
          <button onClick={close} style={buttonStyle}>
            <FontAwesomeIcon icon={faTimes}/>
          </button>
        </div>
      );
  }
};

export default AlertTemplate;